import React from 'react'
import { ImageContainer, MediaSize } from './style'

export interface MediaContainerProps {
  alt: string
  src: string
  size?: MediaSize
  mobilePadding?: number
  hasContent?: boolean
}

export const MediaContainer: React.VFC<MediaContainerProps> = ({ alt, src, size = 'small', mobilePadding, ...props }) => {
  return (
    <ImageContainer size={size} mobilePadding={mobilePadding} {...props}>
      <img src={src} alt={alt} />
    </ImageContainer>
  )
}
